import { Messages } from '~src/codegen/Localize';
import { L10n } from '~src/commonInfra/L10n/L10n';

import {
  ICreatedItemInfo,
  IExplorableItemTypeInfo,
  IIdItemInfo,
} from '../../spacesPlatform/models/resourceInfoParts';

export interface IConnectedApplicationInfo extends IExplorableItemTypeInfo<'connectedApplication'>, IIdItemInfo, ICreatedItemInfo {
  enabled: boolean;
  projectId?: string;
  projectIds?: string[];
  domainSafelist?: string; // space-delimited
  unrestrictedEmbedding?: boolean;
  domainSafelistForDisplay?: string;
  issuerUrl?: string;
  jwksUri?: string;
  connectedApplicationType?: ConnectedApplicationType;
  trustType?: string;
  authorizationServerType?: string;
}

export function localizeConnectedApplicationDomainSafelistForGrid(domains?: string) {
  if (domains === undefined) {
    return Messages.connectedApplicationsDomainsAll();
  }
  if (domains.trim() === '') {
    return Messages.connectedApplicationsDomainsNone();
  }
  const numDomains = domains.split('\n').length;
  return Messages.connectedApplicationsDomainsNumber({
    DOMAIN_COUNT_LOC: L10n.localizedCount(numDomains),
  });
}

export function localizeConnectedApplicationDomainSafelistForDetailPage(domains?: string) {
  if (domains === undefined) {
    return Messages.connectedApplicationsDomainsAll();
  }
  if (domains.trim() === '') {
    return Messages.connectedApplicationsDomainsNone();
  }
  return domains;
}

export enum ConnectedApplicationType {
  DIRECT_TRUST = 'DIRECT_TRUST',
  EAS = 'EAS',
}
